import { render } from "./UserQuotes.vue?vue&type=template&id=442ee40e&scoped=true&lang=pug"
import script from "./UserQuotes.vue?vue&type=script&lang=js"
export * from "./UserQuotes.vue?vue&type=script&lang=js"

import "./UserQuotes.vue?vue&type=style&index=0&id=442ee40e&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442ee40e"]])

export default __exports__